// Field limits aligned with planned PHP allowlist (Unit 4.3)
const FIELD_LIMITS = {
  name: 200,
  email: 320,
  company: 200,
  applicants_per_month: 50,
  message: 2000
};

const ALLOWED_TOPICS = [
  'Talent Triage',
  'Paid Pilot',
  'What Good Looks Like',
  'API & Integrations',
  'Partnering',
  'Something else'
];

const HONEYPOT_FIELD = 'website';
const CONTACT_ENDPOINT = '/contact.php';
const FEEDBACK_CLEAR_MS = 10000;

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function escapeHtml(text) {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function clearFieldErrors(form) {
  form.querySelectorAll('.tt-contact-form__field-error').forEach((el) => el.remove());
  form.querySelectorAll('.is-invalid').forEach((el) => {
    el.classList.remove('is-invalid');
    el.removeAttribute('aria-invalid');
    el.removeAttribute('aria-describedby');
  });
}

function setFieldError(input, message) {
  const field = input.closest('.tt-contact-form__field') || input.parentElement;
  if (!field) return;

  const errorId = `${input.id}-error`;
  let errorEl = field.querySelector(`#${errorId}`);

  if (!errorEl) {
    errorEl = document.createElement('p');
    errorEl.id = errorId;
    errorEl.className = 'tt-contact-form__field-error';
    field.appendChild(errorEl);
  }

  errorEl.textContent = message;
  input.classList.add('is-invalid');
  input.setAttribute('aria-invalid', 'true');
  input.setAttribute('aria-describedby', errorId);
}

function validateContactForm(form) {
  clearFieldErrors(form);

  const honeypot = form.querySelector(`[name="${HONEYPOT_FIELD}"]`);
  if (honeypot && honeypot.value.trim() !== '') {
    return { valid: false, silent: true };
  }

  const fields = [
    { name: 'name', label: 'Name', required: true },
    { name: 'email', label: 'Work email', required: true, email: true },
    { name: 'company', label: 'Company', required: false },
    { name: 'applicants_per_month', label: 'Approx. applicants / month', required: false },
    { name: 'message', label: 'Tell us a little more', required: false }
  ];

  let firstInvalid = null;
  let valid = true;

  const topicInputs = form.querySelectorAll('[name="topics[]"]');
  topicInputs.forEach((input) => {
    if (input.checked && !ALLOWED_TOPICS.includes(input.value)) {
      setFieldError(input, 'Choose a listed topic.');
      valid = false;
      if (!firstInvalid) firstInvalid = input;
    }
  });

  fields.forEach(({ name, label, required, email }) => {
    const input = form.querySelector(`[name="${name}"]`);
    if (!input) return;

    const value = input.value.trim();
    const limit = FIELD_LIMITS[name];

    if (required && !value) {
      setFieldError(input, `${label} is required.`);
      valid = false;
      if (!firstInvalid) firstInvalid = input;
      return;
    }

    if (limit && value.length > limit) {
      setFieldError(input, `${label} must be ${limit} characters or fewer.`);
      valid = false;
      if (!firstInvalid) firstInvalid = input;
      return;
    }

    if (email && value && !EMAIL_PATTERN.test(value)) {
      setFieldError(input, 'Enter a valid work email address.');
      valid = false;
      if (!firstInvalid) firstInvalid = input;
    }
  });

  return { valid, firstInvalid, silent: false };
}

function setFormFeedback(formElement, type, message) {
  const feedbackElement = formElement.querySelector('.feedback');
  if (!feedbackElement) return;
  const alertClass = type === 'success' ? 'alert-success' : 'alert-danger';
  const markup = `<div class="alert ${alertClass}">${escapeHtml(message)}</div>`;
  feedbackElement.innerHTML = markup;
}

function setLoading(formElement, isLoading) {
  formElement.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  const button = formElement.querySelector('[type="submit"]');
  if (!button) return;

  button.disabled = isLoading;
  if (isLoading) {
    button.dataset.defaultLabel = button.textContent;
    button.textContent = 'Sending…';
  } else if (button.dataset.defaultLabel) {
    button.textContent = button.dataset.defaultLabel;
  }
}

const formInit = function formInit() {
  const zforms = document.querySelectorAll('[data-form]');

  if (!zforms.length) return;

  zforms.forEach((form) => {
    let feedbackTimer;

    form.addEventListener('submit', (e) => {
      e.preventDefault();

      if (feedbackTimer) {
        clearTimeout(feedbackTimer);
        feedbackTimer = null;
      }

      const validation = validateContactForm(form);
      if (validation.silent) {
        return;
      }

      if (!validation.valid) {
        setFormFeedback(
          form,
          'error',
          'Please check the highlighted fields and try again.'
        );
        validation.firstInvalid?.focus();
        feedbackTimer = setTimeout(() => {
          const feedbackElement = form.querySelector('.feedback');
          if (feedbackElement) feedbackElement.innerHTML = '';
        }, FEEDBACK_CLEAR_MS);
        return;
      }

      const feedbackElement = form.querySelector('.feedback');
      if (feedbackElement) feedbackElement.innerHTML = '';
      setLoading(form, true);

      const formData = new FormData(form);

      fetch(CONTACT_ENDPOINT, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json'
        }
      })
        .then(async (response) => {
          let result = {};
          try {
            result = await response.json();
          } catch {
            result = {};
          }
          return { response, result };
        })
        .then(({ response, result }) => {
          const message =
            typeof result.message === 'string'
              ? result.message
              : 'Something went wrong. Please try again.';

          if (response.ok && result.ok === true) {
            const successUrl = form.getAttribute('data-success-url');
            if (successUrl) {
              window.location.assign(successUrl);
              return;
            }
            setFormFeedback(form, 'success', message);
            form.reset();
            clearFieldErrors(form);
          } else {
            setFormFeedback(form, 'error', message);
          }
        })
        .catch(() => {
          setFormFeedback(
            form,
            'error',
            'Network error. Please check your connection and try again.'
          );
        })
        .finally(() => {
          setLoading(form, false);
          feedbackTimer = setTimeout(() => {
            const feedbackEl = form.querySelector('.feedback');
            if (feedbackEl) feedbackEl.innerHTML = '';
          }, FEEDBACK_CLEAR_MS);
        });
    });
  });
};

export default formInit;
